<template>
    <v-container class="ma-0 pa-0 steps_container" fill-height>
        <v-row dense class="ma-0 pa-0">
			<v-col cols="12" align-self="start" class="ma-0 pa-0">
                <v-nav-guide
                    title="0"
                />
			</v-col>
		</v-row>

        <v-row dense class="ma-0 pa-0">
			<v-col cols="12" align-self="start" class="ma-0 pa-0">
                <v-img :src="require('@/assets/images/renew/img-illust-disease.svg')" />
			</v-col>
		</v-row>

        <v-row dense class="ma-0 pa-0 px-7 pt-7">
			<v-col cols="12" align-self="start" class="ma-0 pa-0">
                <p style="font-size:14px; font-weight:bolder; color:#da668a; letter-spacing:-0.6px;">질환 분석</p>
                <template v-if="warningCount >= 3">
                    <p style="font-size:24px; font-weight:bolder; color:#193263; letter-spacing:-1px;">건강에 조금 더 신경써주세요!</p>
                </template>
                <template v-else>
                    <p style="font-size:24px; font-weight:bolder; color:#193263; letter-spacing:-1px;">평소에 건강을 신경쓰시는군요!</p>
                </template>
			</v-col>
		</v-row>
        
        <v-row dense class="ma-0 pa-0">
			<v-col cols="12" align-self="start" class="ma-0 pa-0">
				<template v-for="(disease, idx) in diseaseList" >
                    <v-disease-card-detail
                        :disease="disease.name"
                        :index="disease.index"
                        :key="idx"
                    />
                </template>
			</v-col>
		</v-row>
            
        <v-row dense class="ma-0 pa-7 footer_bg">
			<v-col cols="12" align-self="end" class="footer_title" v-html="$t('disease.footer-title')"/>
            <v-col cols="12" align-self="end">
				<ul role="listbox">
                    <li  class="footer_desc" role="listitem">{{$t('disease.footer-list1')}}</li>
                    <li  class="footer_desc" role="listitem">{{$t('disease.footer-list2')}}</li>
                    <li  class="footer_desc" role="listitem">{{$t('disease.footer-list3')}}</li>
                </ul>
			</v-col>
            <v-col cols="12" align-self="end" class="footer_origin" v-html="$t('disease.footer-origin')"/>
		</v-row>

    </v-container>
</template>
<script>
    import { mapGetters } from 'vuex'
    import VDiseaseCardDetail from "@/components/diseaseCardDetail"
    import VNavGuide from "@/components/navGuide"

    export default {
        components: {
            VDiseaseCardDetail,
            VNavGuide,
        },
        data() {
            return {
                warningCount: 0,
            }
        },
        computed: {
            ...mapGetters('survey', [
                'checkupResult'
            ]),
            isDBInsurance() {
                if( process.env.VUE_APP_TARGET_COMPANY === 'db-insurance') {
                    return true
                }
                return false
            },
            diseaseList() {
                const diseaseList = [
                    {
                        name: '당뇨병',
                        index: this.checkupResult.dmIndex
                    },
                    {
                        name: '간암',
                        index: this.checkupResult.liverIndex
                    },
                    {
                        name: '대장암',
                        index: this.checkupResult.colorectalIndex
                    },
                    {
                        name: '위암',
                        index: this.checkupResult.stomachIndex
                    },
                    {
                        name: '폐암',
                        index: this.checkupResult.lungIndex
                    },
                    {
                        name: '전립선암',
                        index: this.checkupResult.prostateIndex
                    },
                    {
                        name: '유방암',
                        index: this.checkupResult.breastIndex
                    },
                    {
                        name: '치매',
                        index: this.checkupResult.dementiaIndex
                    },
                    {
                        name: '심장질환',
                        index: this.checkupResult.heartIndex
                    },
                    {
                        name: '뇌졸중',
                        index: this.checkupResult.strokeIndex
                    },
                ]

                if(!this.isDBInsurance) {
                    diseaseList.splice(7, 3)
                }

                let toBeDeleted = -1
                if(this.checkupResult.gender === '1') {
                    toBeDeleted = diseaseList.findIndex(disease => {
                        return (disease.name === '유방암')
                    })
                }
                else if(this.checkupResult.gender === '2') {
                    toBeDeleted = diseaseList.findIndex(disease => {
                        return (disease.name === '전립선암')
                    })
                }
                if(toBeDeleted > -1) {
                    diseaseList.splice(toBeDeleted, 1)
                }

                diseaseList.forEach(element => {
                    if(element.index !== 0){
                        this.warningCount++
                    } 
                });

                return diseaseList
            },
            getDate() {
                return this.checkupResult.displayCheckupDate
            },
        },
        methods: {
        },
        mounted() {
            window.scrollTo(0, 0)
        }
    }
</script>
<style scoped>
    .main-container {
        font-family: "NanumSquare", sans-serif;
        padding: 0px 30px;
    }
    .footer {
        margin-top: -40px;
        padding: 30px;
        background-color: #dddddd;
        font-family: "NanumSquare", sans-serif;
        font-size: 14px;
        color: black;
        line-height: 160%;
    }
    .footer_title {
        font-weight: bolder;
        font-size: 14px;
        color: #193263;
        line-height: 20px;
        letter-spacing: -0.6px;
    }
    .footer_origin {
        font-size:12px;
        line-height: 20px;
        letter-spacing: -0.51px;
        color:#193263;
        font-weight: bolder;
    }
    .footer_desc {
        font-size:12px;
        list-style: disc;
        font-size: 12px;
        color:#7584a1;
        line-height: 18px;
        letter-spacing: -0.6px;
        margin-bottom: 10px;
        margin-left: 10px;
    }

    .footer_bg {
        background-color: #f3f5f7;
    }
</style>
